exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".LZXNp271KHE9PRfN0jPs4,.Pr3GRVMsdVpM-NggOYrLc{float:left;width:100%;display:inline-block}@media (min-width:900px){.Pr3GRVMsdVpM-NggOYrLc{width:55%}.LZXNp271KHE9PRfN0jPs4{width:45%}}", ""]);

// exports
exports.locals = {
	"leftColumn": "Pr3GRVMsdVpM-NggOYrLc",
	"rightColumn": "LZXNp271KHE9PRfN0jPs4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules!./~/postcss-loader!./src/styles/electrify.css
// module id = 349
// module chunks = 0